<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>

<div class="row modal-content slider-content watermark-bg">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeSlideShow()"
        style="top:-15px; z-index: 1;">
        <span aria-hidden="true" class="">&times;</span>
    </button>
    <div class="row ka-em-slide-counts"  *ngIf="slideShowData.length > 0">
        <div class="col-md-3">
            Total Records : {{currentSlider}} of {{slideShowCount}}
        </div>
        <div class="col-md-2">Viewed {{viewCount}} Profiles

        </div>
        <div class="col-md-1">
            <input matInput class="form-control" placeholder="Go to" (focusout)="onGoToFieldChange($event)"
            (keydown.enter)="onGoToFieldChange($event)" (keypress)="omit_specialChar_and_char($event)">
        </div>
        <div class="col-md-2">
            <span style="cursor: pointer;" (click)="activateSlideShow(isSlideShowActivated)"><img
                    *ngIf="isSlideShowActivated===false" src="../../../../assets/img/profile/slideshow_ic.svg"
                    alt=""></span>
            <span style="cursor: pointer;" (click)="activateSlideShow(isSlideShowActivated)"><img
                    *ngIf="isSlideShowActivated===true" src="../../../../assets/img/profile/slideshow_ic.svg"
                    alt=""></span>
        </div>
    </div>
    <div class="col-md-12" *ngIf="slideShowData.length > 0">
        <button type="button" class="arrow-common slide-profile-left">
            <img *ngIf="currentSlider >1" src="../../../../assets/img/home/leftarrow_ic.svg" alt=""></button>
        <button type="button" class="arrow-common slide-profile-right">
            <img *ngIf="currentSlider < slideShowCount" src="../../../../assets/img/home/rightarrow_ic.svg"
                alt=""></button>
        <ngx-slick-carousel #slickModal="slick-carousel" [config]="slideConfig"
            (afterChange)="afterChange($event)" (beforeChange)="beforeChange($event)">
            <div ngxSlickItem *ngFor="let profile of slideShowData" class="imgContainer">
                <div class="row" *ngIf="mode==='editView' || mode==='profileValidation'">

                    <div class="col-md-6" style="padding: 30px;">
                        <div class="row">
                            <div class="col ka-em-slide-content-label">ProfileId</div>
                            :
                            <div class="col">
                                <span style="cursor: pointer;">
                                    <i class="fa  fa-clipboard" (click)="copyProfileId(profile['profileID'])"
                                        *ngIf="mode==='editView'" aria-hidden="true"></i>
                                    <i class="fa fa-clipboard" (click)="copyProfileId(profile['viewfullProfileID'])"
                                        *ngIf="mode==='profileValidation'" aria-hidden="true"></i>

                                </span> <span (click)="copyProfileId(profile['profileID'])" *ngIf="mode==='editView'"
                                    class="ka-em-profileId"
                                    (click)="navigateToViewProfileByProfileId(profile['profileID'])" [ngStyle]="{'color':getAssignTktColour(profile['paidSatus'])}">{{getProfileTypeWithProfileID(profile)}}</span>
                                <span *ngIf="mode==='profileValidation'" class="ka-em-profileId"
                                    (click)="copyProfileId(profile['viewfullProfileID'])"
                                    (click)="navigateToViewProfileByProfileId(profile['viewfullProfileID'])"
                                    [ngStyle]="{'color':getAssignTktColour(profile['paidSatus'])}">{{getProfileTypeWithProfileID(profile)}}</span>
                                {{profile['kmplid']}}

                            </div>
                            <div class="col-md-2">
                                <img (click)="naviagteToHoroscope(profile['horoScopeImage'])"
                                    *ngIf="profile['horoscopeStatus'] === 1"
                                    src="../../../../assets/img/dashboard/ico_horoscope.jpg"
                                    style=" width: 30% !important;height: 20px !important; padding: 0px !important;cursor: pointer;margin-left: -86%;">

                            </div>
                        </div>
                        <div class="row">
                            <div class="col ka-em-slide-content-label">Name</div> :
                            <div class="col">
                                {{profile['lastName']}} {{profile['firstName']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row">
                            <div class="col ka-em-slide-content-label">Caste</div> :
                            <div class="col">
                                {{profile['mothertongue']}} - {{profile['caste']}}
                            </div>
                            <div class="col-md-2"></div>
                        </div>
                        <div class="row">
                            <div class="col ka-em-slide-content-label">Dor</div> :
                            <div class="col">{{profile['dor']}}</div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row">
                            <div class="col ka-em-slide-content-label">Profile Grade</div> :
                            <div class="col">
                                <span *ngIf="profile['profileGrade']===1">A</span>
                                <span *ngIf="profile['profileGrade']===2">B</span>
                                <span *ngIf="profile['profileGrade']===3">C</span>
                                <span *ngIf="profile['profileGrade']===null">---</span>


                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row">
                            <div class="col ka-em-slide-content-label">Last Login</div> :

                            <div class="col"
                                *ngIf="profile['lastLoginDate']!=null && profile['lastLoginDate']!='' && profile['lastLoginDate']!=undefined">
                                <span>{{profile['lastLoginDate']}}</span>
                            </div>
                            <div class="col ka-em-profileId"
                                *ngIf="mode === 'editView' && (profile['lastLoginDate']===null || profile['lastLoginDate']==='' || profile['lastLoginDate']===undefined)">
                                <span (click)="forgotPassword(profile['profileID'])">
                                    Forgot Password
                                </span>
                            </div>
                            <div class="col ka-em-profileId"
                                *ngIf="mode === 'profileValidation' && (profile['lastLoginDate']===null || profile['lastLoginDate']==='' || profile['lastLoginDate']===undefined)">
                                <span (click)="forgotPassword(profile['viewfullProfileID'])">
                                    Forgot Password
                                </span>
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row">
                            <div class="col ka-em-slide-content-label">Send/Recv</div> :
                            <div class="col">
                                <span *ngIf="profile['srCount']!=null && mode==='editView'" class="ka-em-profileId"
                                    (click)="navigateToCommunicationLog(profile['profileID'])">
                                    {{profile['srCount']}}
                                </span>
                                <span *ngIf="profile['srCount']!=null && mode==='profileValidation'"
                                    class="ka-em-profileId"
                                    (click)="navigateToCommunicationLog(profile['viewfullProfileID'])">
                                    {{profile['srCount']}}
                                </span>
                                <span *ngIf="profile['srCount']===null">No Service</span>

                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row">
                            <div class="col ka-em-slide-content-label">Payment</div> :
                            <div class="col ">
                                <span
                                    *ngIf="profile['paidAmount']!=null && profile['paidAmount']!='' && mode==='editView'"
                                    class="ka-em-profileId"
                                    (click)="navigateToPaymentPage(profile['profileID'])">{{profile['paidAmount']}}</span>
                                <span
                                    *ngIf="profile['paidAmount']!=null && profile['paidAmount']!='' && mode==='profileValidation'"
                                    class="ka-em-profileId"
                                    (click)="navigateToPaymentPage(profile['viewfullProfileID'])">{{profile['paidAmount']}}</span>
                                <span *ngIf="profile['paidAmount']===null || profile['paidAmount']===''">Not
                                    Paid</span>
                            </div>
                            <div class="col-md-2"></div>


                        </div>
                        <div class="row" *ngIf="profile['expiryDate']!=null && profile['expiryDate']!=''">
                            <div class="col ka-em-slide-content-label">Expiry Date</div> :
                            <div class="col ">
                                <span (click)="navigateToPaymentPage(profile['profileID'])" class="ka-em-profileId"
                                    *ngIf="mode==='editView'">
                                    {{profile['expiryDate']}}</span>
                                <span (click)="navigateToPaymentPage(profile['viewfullProfileID'])"
                                    class="ka-em-profileId" *ngIf="mode==='profileValidation'">
                                    {{profile['expiryDate']}}</span>
                                <span *ngIf="profile['points']!=null">({{profile['points']}})</span>

                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row">
                            <div class="col ka-em-slide-content-label">Marketing Ticket</div> :
                            <div class="col" *ngIf="mode==='editView'">
                                <span class="ka-em-profileId"
                                    (click)="viewMarketingTicket(profile['emp_Ticket_ID'])">{{profile['ticketID']}}
                                </span>
                                <span> ({{profile['profileOwnername']}} - {{profile['empUserName']}})</span>

                            </div>
                            <div class="col" *ngIf="mode==='profileValidation'">
                                <span class="ka-em-profileId"
                                    (click)="viewMarketingTicket(profile['ticketHistoryID'])">{{profile['ticketHistoryID']}}
                                </span>
                                <span> ({{profile['profileOwnername']}} - {{profile['empUserName']}})</span>

                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row">
                            <div class="col ka-em-slide-content-label">Match Meetings</div> :
                            <div class="col">
                                <span *ngIf="mode==='editView'" class="ka-em-profileId"
                                    (click)="navigateToCommunicationLog(profile['profileID'])">
                                    {{profile['matchMeetingCount']}}
                                </span>
                                <span *ngIf="mode==='profileValidation'" class="ka-em-profileId"
                                    (click)="navigateToCommunicationLog(profile['viewfullProfileID'])">
                                    {{profile['matchMeetingCount']}}
                                </span>

                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <!-- <div class="row">
                            <div class="col ka-em-slide-content-label">SA Form</div> :
                            <div class="col">
                                <span *ngIf="profile['saForm']!=null" (click)="viewSAForm(profile['saForm'])"
                                    class="ka-em-profileId">View SA
                                    Form</span>
                                <span *ngIf="profile['saForm']===null &&  mode==='editView'"
                                    (click)="uploadSAForm(profile['profileID'])" class="ka-em-SAForm">Upload SA
                                    Form</span>
                                <span *ngIf="profile['saForm']===null &&  mode==='profileValidation'"
                                    (click)="uploadSAForm(profile['viewfullProfileID'])" class="ka-em-SAForm">Upload SA
                                    Form</span>

                            </div>
                            <div class="col-md-2"></div>

                        </div> -->
                    </div>
                    <div class="col-md-6">
                        <div class="row" *ngIf="mode==='editView'">
                            <img src="{{profile['photo']}}"
                                (click)="getUserPhotoGal(profile['photo'],profile['cust_ID'])"
                                style="cursor: pointer;font-size: 13px;">
                        </div>
                        <div class="row" *ngIf="mode==='profileValidation'">
                            <img src="{{profile['customerFullPhoto']}}"
                                (click)="getUserPhotoGal(profile['customerFullPhoto'],profile['cust_ID'])"
                                style="cursor: pointer;font-size: 13px;">
                        </div>
                        <div class="row" style="justify-content: center;">
                            <span *ngIf="profile['photoCount']===0 && mode==='editView'" class="ka-em-photo-count"
                                (click)="photoRequest(profile['profileID'])">Photo
                                Request</span>
                            <span *ngIf="profile['photoCount']===0 && mode==='profileValidation'"
                                class="ka-em-photo-count" (click)="photoRequest(profile['viewfullProfileID'])">Photo
                                Request</span>
                            <span *ngIf="profile['photoCount']>0">No Of Photos:
                                {{profile['photoCount']}}</span>

                        </div>
                        <div class="row">
                            <div class="col-md-4 ka-em-slide-content-email">Primary Email</div>
                            <div class="col">
                                :
                                <i class="fa fa-clipboard" aria-hidden="true" style="cursor: pointer;"
                                    (click)="copyEmail(profile['primaryemail'])" matTooltip="Copy Email"></i>
                                <span style="padding-left: 1%;">{{profile['primaryemail']}}</span>
                                <span *ngIf="profile['cEmailVerStatus']===null || profile['cEmailVerStatus']===false"
                                    class="ka-em-mobile-email">
                                    <i class="far fa-check-circle"></i> <span class="ka-em-profileId"
                                        (click)="verifyEmail(profile['cust_ID'])">Verify Email</span>
                                </span>
                                <span *ngIf="profile['cEmailVerStatus']!=null &&  profile['cEmailVerStatus']===true"
                                    style="color: green;" class="ka-em-mobile-email"><i
                                        class="far fa-check-circle"></i></span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 ka-em-slide-content-email">Primary Mobile</div>
                            <div class="col">
                                :
                                <i class="fa fa-clipboard" aria-hidden="true" style="cursor: pointer;"
                                    (click)="copyMobileNo(profile['primarynumber'])" matTooltip="Copy MobileNo"></i>
                                <span style="padding-left: 1%;">{{profile['primarynumber']}}</span>
                                <span *ngIf="profile['cNumberVerStatus']===null || profile['cNumberVerStatus']===false"
                                    class="ka-em-mobile-email">
                                    <i class="far fa-check-circle"></i> <span class="ka-em-profileId"
                                        (click)="verifyMobileNumber(profile['cust_ID'],profile['primarynumber'])">Verify
                                        Mobile</span>
                                </span>
                                <span *ngIf="profile['cNumberVerStatus']!=null &&  profile['cNumberVerStatus']===true"
                                    style="color: green;" class="ka-em-mobile-email"><i
                                        class="far fa-check-circle"></i></span>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row" *ngIf="mode==='myProfile'">
                    <div class="col-md-6" style="padding: 30px;">
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">ProfileId</div> :
                            <div class="col">
                                <span style="cursor: pointer;">
                                    <i class="fa  fa-clipboard" (click)="copyProfileId(profile['profileID'])"
                                        aria-hidden="true"></i>
                                </span>
                                <span (click)="copyProfileId(profile['profileID'])" *ngIf="mode==='myProfile'"
                                    class="ka-em-profileId"(click)="navigateToViewProfileByProfileId(profile['profileID'])"
                                    [ngStyle]="{'color':getAssignTktColour(profile['paidSatus'])}">{{getProfileTypeWithProfileID(profile)}}
                                    <span *ngIf="profile?.BrokerCode != null">({{profile?.BrokerCode}})</span>
                                </span>
                                <span *ngIf="profile?.KMPLID != null"> - {{profile?.KMPLID}}</span>
                            </div>
                            <div class="col-md-2">
                                <img (click)="naviagteToHoroscope(profile['horoScopeImage'])"
                                    *ngIf="profile['horoscopeStatus'] === 1"
                                    src="../../../../assets/img/dashboard/ico_horoscope.jpg"
                                    style=" width: 30% !important;height: 20px !important; padding: 0px !important;cursor: pointer;margin-left: -86%;">

                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Name</div> :
                            <div class="col font-weight-bold">
                                {{profile['lastName']}} {{profile['firstName']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">DOB(Age)</div> :
                            <div class="col font-weight-bold">
                                {{profile['DOB']}}({{profile['Age']}})
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Height</div> :
                            <div class="col font-weight-bold">
                                {{profile['Height']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">TOB(Star)</div> :
                            <div class="col font-weight-bold">
                                {{profile['TOB']}}({{profile['Star']}})
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Place of birth</div> :
                            <div class="col font-weight-bold">
                                {{profile['PlaceOfBirth']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Gothram</div> :
                            <div class="col font-weight-bold">
                                {{profile['Gothram']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Caste</div> :
                            <div class="col font-weight-bold">
                                {{profile['mothertongue']}} - {{profile['caste']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Marital Status</div> :
                            <div class="col font-weight-bold">
                                {{profile['MaritalStatus']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Qualification</div> :
                            <div class="col font-weight-bold">
                                {{profile['qualification']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Education Category</div> :
                            <div class="col font-weight-bold">
                                {{profile['EducationCategory']}} 
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Profession</div> :
                            <div class="col font-weight-bold">
                                {{profile['Profession']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Job Location</div> :
                            <div class="col font-weight-bold">
                                {{profile['JobLocation']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Income(P.M)</div> :
                            <div class="col font-weight-bold">
                                {{profile['Income']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Father/Mother Native</div> :
                            <div class="col font-weight-bold">
                                {{profile['FFNative']}} / {{profile['MFNative']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Property</div> :
                            <div class="col font-weight-bold">
                                {{profile['Property']}} <span *ngIf="profile?.Property != null">({{profile['PropertyType']}})</span>
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label font-weight-bold" [ngStyle]="{'color': profile['InterestedInIntercaste'] === true ? '#a326bc' : 'black'}">Caste No Bar</div> :
                            <div class="col font-weight-bold" [ngStyle]="{'color': profile['InterestedInIntercaste'] === true ? '#a326bc' : 'black'}">
                                {{profile['InterestedInIntercaste'] === true ? 'Yes' : 'No'}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                      
                    </div>
                    <div class="col-md-6">
                        <div class="row ka-slideShow-image">
                            <img src="{{profile['ApplicationPhotoPath']}}" class="myprofile-img"
                                (click)="getUserPhotoGal(profile['ApplicationPhotoPath'],profile['cust_ID'])"
                                style="cursor: pointer;">
                        </div>
                        <div class="row" style="justify-content: center;">
                            <span *ngIf="profile['photoCount']===0" class="ka-em-photo-count"
                                (click)="photoRequest(profile['profileID'])">Photo
                                Request</span>
                            <span *ngIf="profile['photoCount']>0">No Of Photos:
                                {{profile['photoCount']}}</span>

                        </div>
                        <div class="container" *ngIf="DorTable">
                            <div class="row d-flex justify-content-center">                                
                                <div class="col p-1 ml-5 d-flex justify-content-end">                                    
                                    <span style="padding-left: 1%;">
                                        <i class="far fa-solid fa-envelope ka-slideshow-icon" style="cursor: pointer;" aria-hidden="true"
                                        matTooltip="{{profile?.primaryemail}}" (click)="showDetails(profile?.primaryemail)" [ngStyle] ="{'color':profile['cEmailVerStatus']!=null &&  profile['cEmailVerStatus']===true?'green':'black'}"></i>
                                    </span>
                                    <span *ngIf="profile['cEmailVerStatus']===null || profile['cEmailVerStatus']===false"
                                        class="ka-em-mobile-email">
                                         <span class="ka-em-profileId"
                                            (click)="verifyEmail(profile['cust_ID'])"><i class="far fa-times-circle ka-slideshow-icon" matTooltip = "Not Verified" style="color: red;"></i></span>
                                    </span>
                                    <span *ngIf="profile['cEmailVerStatus']!=null &&  profile['cEmailVerStatus']===true"
                                        style="color: green;" class="ka-em-mobile-email"><i
                                            class="far fa-check-circle ka-slideshow-icon" matTooltip="Verified"></i></span>
                                </div>
                                <div class="col p-1 mr-5">                                    
                                    <span style="padding-left: 1%;">
                                        <i class="fas fa-mobile-alt ka-slideshow-icon" style="cursor: pointer;" aria-hidden="true" [ngStyle] ="{'color':profile['cNumberVerStatus'] != null &&  profile['cNumberVerStatus'] === true?'green':'black'}"
                                        matTooltip="{{profile?.primarynumber}}" (click)="showDetails(profile?.primarynumber)"></i>
                                    </span>
                                    <span *ngIf="profile['cNumberVerStatus']===null || profile['cNumberVerStatus']===false"
                                        class="ka-em-mobile-email">
                                         <span class="ka-em-profileId"
                                            (click)="verifyMobileNumber(profile['cust_ID'],profile['primarynumber'])"><i class="far fa-times-circle ka-slideshow-icon" matTooltip = "Not Verified" style="color: red;"></i></span>
                                    </span>
                                    <span *ngIf="profile['cNumberVerStatus']!=null &&  profile['cNumberVerStatus']===true"
                                        style="color: green;" class="ka-em-mobile-email" matTooltip="Verified"><i
                                            class="far fa-check-circle ka-slideshow-icon"></i></span>
                                            <span (click)="getOfficePurposeData(profile.cust_ID)"
                                            *ngIf="profile.Gender === 'Male'" style="font-size: 18px;cursor: pointer;padding-left: 10px;" [ngClass]="{'ka-em-officePurposeGroom': profile.isAboutProfile}">
                                              <i class="fas fa-comment"></i></span>
                                              <span (click)="getOfficePurposeData(profile.cust_ID)"
                                            *ngIf="profile.Gender === 'Female'" style="font-size: 18px;cursor: pointer;padding-left: 10px;" [ngClass]="{'ka-em-officePurposeBride': profile.isAboutProfile}">
                                              <i class="fas fa-comment"></i></span>
                                
                            </div>
                            </div>                        
                                
                            
                        </div>
                        <div class="ka-em-slideOwnerDetails px-4" *ngIf="!AssignOwner">
                            <div class="row" *ngIf="profile['PrimaryProfileOwner'] !== null">
                                <span class="ka-ownerLabel  col-4">Profile Owner </span> 
                                <span class="col-8"> : {{profile['PrimaryProfileOwner']}}
                                    <span> - {{profile['PrimaryOwnerNumber']}}</span>
                                </span>
                            </div>
                            <div class="row" *ngIf="profile['SecondaryProfileOwner'] !== null">
                                <span class="ka-ownerLabel  col-4">Secondary Owner  </span>                                          
                                <span class="col-8"> : {{profile['SecondaryProfileOwner']}}
                                    <span> - {{profile['SecondaryProfileOwnerNumber']}}</span>
                                </span> 
                            </div>                                   
                        </div>
                        <div class="top-section pl-3 pr-3 pt-1 pb-1" *ngIf="DorTable">
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">DOR</div> :
                                <div class="col font-weight-bold">
                                    {{profile['dor']}}
                                </div>
                                
                            </div>
                            <!-- <div class="row">
                                <div class="col ka-em-slide-content-label">Education Grade</div> :
                                <div class="col font-weight-bold">
                                    {{profile['EducationGrade']}}
                                </div>
                                
                            </div> -->
                            <!-- <div class="row">
                                <div class="col ka-em-slide-content-label">Payment Offer</div> :
                                <div class="col font-weight-bold">
                                    <span style="color: #06347e; cursor: pointer;" (click)="navigateToViewOffers(profile?.profileID)" *ngIf="profile?.offerStatus === 1;else viewOffer">View Offers</span>
                                    <ng-template #viewOffer>
                                        <span *ngIf="loginData['isAdmin'] === 1" style="color: red; cursor: pointer;" (click)="openPaymentOffer(profile)">Create Offer</span>
                                        <span *ngIf="loginData['isAdmin'] !== 1" style="color: red;">Create Offer</span>
                                    </ng-template>
                                </div>
                                
                            </div> -->
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Last Login</div> :
    
                                <div class="col font-weight-bold"
                                    *ngIf="profile['lastLoginDate']!=null && profile['lastLoginDate']!='' && profile['lastLoginDate']!=undefined">
                                    <span>{{profile['lastLoginDate']}}</span>
                                </div>
                                <div class="col ka-em-profileId"
                                    *ngIf="(profile['lastLoginDate']===null || profile['lastLoginDate']==='' || profile['lastLoginDate']===undefined)">
                                    <span (click)="forgotPassword(profile['profileID'])">
                                        Forgot Password
                                    </span>
                                </div>
                                
    
                            </div>
                            <!-- <div class="row">
                                <div class="col ka-em-slide-content-label">Mobile Last Login</div> :
    
                                <div class="col font-weight-bold"
                                    *ngIf="profile['LastMobileLoginDate']!=null && profile['LastMobileLoginDate']!='' && profile['LastMobileLoginDate']!=undefined">
                                    <span>{{profile['LastMobileLoginDate']}}</span>
                                </div>
                                <div class="col ka-em-profileId"
                                    *ngIf="(profile['LastMobileLoginDate']===null || profile['LastMobileLoginDate']==='' || profile['LastMobileLoginDate']===undefined)">
                                    <span (click)="forgotPassword(profile['profileID'])">
                                        Forgot Password
                                    </span>
                                </div>
                                
    
                            </div> -->
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Send/Recv</div> :
                                <div class="col font-weight-bold">
                                    <span *ngIf="profile['srCount']!=null" class="ka-em-profileId"
                                        (click)="navigateToCommunicationLog(profile['profileID'])">
                                        {{profile['srCount']}}
                                    </span>
                                    <span style="color: red;" *ngIf="profile['srCount']===null">No Service</span>
    
                                </div>
                                
    
                            </div>
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Payment</div> :
                                <div class="col font-weight-bold">
                                    <span *ngIf="profile['paidAmount']!=null && profile['paidAmount']!=''"
                                        class="ka-em-profileId" (click)="navigateToPaymentPage(profile['profileID'])">{{profile['paidAmount']}} ({{profile['paymentDate']}})</span>
                                    <span style="color: red;" *ngIf="profile['paidAmount']===null || profile['paidAmount']===''">Not
                                        Paid</span>
                                </div>
                                
    
    
                            </div>
                            <div class="row" [hidden]="profile['expiryDate'] == null || profile['expiryDate'] == ''">
                                <div class="col-4 ka-em-slide-content-label">Expired Date</div> :
                                <div class="col font-weight-bold">
                                    <span style="color: red; cursor: pointer;" (click)="navigateToPaymentPage(profile['profileID'])">{{profile['expiryDate']}} ({{profile['points']}})</span>
                                </div>
                                
    
                            </div>
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Marketing Ticket</div> :
                                <div class="col font-weight-bold">
                                    <span class="ka-em-profileId"
                                        (click)="viewMarketingTicket(profile['Emp_Ticket_ID'])">{{profile['ticketID']}}
                                    </span>
                                    <span> ({{profile['profileOwnername']}} - {{profile['empUserName']}})</span> ({{profile?.NoofDays === 1 ? (profile?.NoofDays + ' day') : (profile?.NoofDays + ' days')}})
    
                                </div>
                                
    
                            </div>
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Match Meetings</div> :
                                <div class="col font-weight-bold">
                                    <span class="ka-em-profileId"
                                        (click)="navigateToCommunicationLog(profile['profileID'])">
                                        {{profile['matchMeetingCount']}}
                                    </span>
                                </div>
                                
    
                            </div>
                            <!-- <div class="row">
                                <div class="col-4 ka-em-slide-content-label">SA Form</div> :
                                <div class="col font-weight-bold">
                                    <span style="color: #06347e;" *ngIf="profile['saForm']!=null" (click)="viewSAForm(profile['saForm'])"
                                        class="ka-em-profileId">View SA
                                        Form</span>
                                    <span style="color: red;" *ngIf="profile['saForm']===null"
                                        (click)="uploadSAForm(profile['profileID'])" class="ka-em-SAForm">Upload SA
                                        Form</span>
    
                                </div>
                                
    
                            </div> -->
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Last Service Date</div> :
                                <div class="col font-weight-bold">
                                    <span>{{profile['lastService_Date']}}</span>
                                </div>
                                
    
                            </div>
                            <!-- <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Website/Mobile Login Count</div> :
                                <div class="col font-weight-bold">
                                    <span>{{profile['websiteLoginCount']}} / {{profile['mobileLoginCount']}}</span>
                                </div>
                                
    
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="mode==='dash'">
                    <div class="col-md-6" style="padding: 30px;">
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">ProfileId</div> :
                            <div class="col">
                                <span style="cursor: pointer;">
                                    <i class="fa  fa-clipboard" (click)="copyProfileId(profile['profileID'])"
                                        aria-hidden="true"></i>
                                </span>
                                <span (click)="copyProfileId(profile['profileID'])" *ngIf="mode==='dash'"
                                    class="ka-em-profileId"(click)="navigateToViewProfileByProfileId(profile['profileID'])"
                                    [ngStyle]="{'color':getAssignTktColour(profile['paidSatus'])}">{{getProfileType(profile)}}
                                    <span *ngIf="profile?.BrokerCode != null">({{profile?.BrokerCode}})</span>
                                </span>
                                <span *ngIf="profile?.BranchCode != null" style="color: rgb(173, 102, 240);"> - {{profile?.BranchCode}}</span>
                            </div>
                            <div class="col-md-2">
                                <img (click)="naviagteToHoroscope(profile['horoScopeImage'])"
                                    *ngIf="profile['horoscopeStatus'] === 1"
                                    src="../../../../assets/img/dashboard/ico_horoscope.jpg"
                                    style=" width: 30% !important;height: 20px !important; padding: 0px !important;cursor: pointer;margin-left: -86%;">

                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Name</div> :
                            <div class="col font-weight-bold">
                                {{profile['lastName']}} {{profile['firstName']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">DOB(Age)</div> :
                            <div class="col font-weight-bold">
                                {{profile['DOB']}}({{profile['Age']}})
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Height</div> :
                            <div class="col font-weight-bold">
                                {{profile['Height']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">TOB(Star)</div> :
                            <div class="col font-weight-bold">
                                {{profile['TOB']}}({{profile['Star']}})
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Place of birth</div> :
                            <div class="col font-weight-bold">
                                {{profile['PlaceOfBirth']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Gothram</div> :
                            <div class="col font-weight-bold">
                                {{profile['Gothram']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Caste</div> :
                            <div class="col font-weight-bold">
                                {{profile['mothertongue']}} - {{profile['caste']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Marital Status</div> :
                            <div class="col font-weight-bold">
                                {{profile['MaritalStatus']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Qualification</div> :
                            <div class="col font-weight-bold">
                                {{profile['qualification']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Education Category</div> :
                            <div class="col font-weight-bold">
                                {{profile['EducationCategory']}} 
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Profession</div> :
                            <div class="col font-weight-bold">
                                {{profile['Profession']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Job Location</div> :
                            <div class="col font-weight-bold">
                                {{profile['JobLocation']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Income(P.M)</div> :
                            <div class="col font-weight-bold">
                                {{profile['Income']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Father/Mother Native</div> :
                            <div class="col font-weight-bold">
                                {{profile['FFNative']}} / {{profile['MFNative']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Property</div> :
                            <div class="col font-weight-bold">
                                {{profile['Property']}} <span *ngIf="profile?.Property != null">({{profile['PropertyType']}})</span>
                            </div>
                            <div class="col-md-2"></div>

                        </div>


                      
                    </div>
                    <div class="col-md-6">
                        <div class="row ka-slideShow-image">
                            <img src="{{profile['ApplicationPhotoPath']}}" class="myprofile-img"
                                (click)="getUserPhotoGal(profile['ApplicationPhotoPath'],profile['cust_ID'])"
                                style="cursor: pointer;">
                        </div>
                        <div class="row" style="justify-content: center;">
                            <span *ngIf="profile['photoCount']===0" class="ka-em-photo-count"
                                (click)="photoRequest(profile['profileID'])">Photo
                                Request</span>
                            <span *ngIf="profile['photoCount']>0">No Of Photos:
                                {{profile['photoCount']}}</span>

                        </div>
                        <div class="container">
                            <div class="row d-flex justify-content-center">                                
                                <div class="col p-1 ml-5 d-flex justify-content-end">                                    
                                    <span style="padding-left: 1%;">
                                        <i class="far fa-solid fa-envelope ka-slideshow-icon" style="cursor: pointer;" aria-hidden="true" 
                                        matTooltip="{{profile?.primaryemail}}" (click)="showDetails(profile?.primaryemail)" [ngStyle] ="{'color':profile['cEmailVerStatus']!=null &&  profile['cEmailVerStatus']===true?'green':'black'}"></i>
                                    </span>
                                    <span *ngIf="profile['cEmailVerStatus']===null || profile['cEmailVerStatus']===false"
                                        class="ka-em-mobile-email">
                                         <span class="ka-em-profileId"
                                            (click)="verifyEmail(profile['cust_ID'])"><i class="far fa-times-circle ka-slideshow-icon" matTooltip="Not Verified" style="color: red;"></i></span>
                                    </span>
                                    <span *ngIf="profile['cEmailVerStatus']!=null &&  profile['cEmailVerStatus']===true"
                                        style="color: green;" class="ka-em-mobile-email"><i
                                            class="far fa-check-circle ka-slideshow-icon" matTooltip="Verified"></i></span>
                                </div>
                                <div class="col p-1 mr-5">                                    
                                    <span style="padding-left: 1%;">
                                        <i class="fas fa-mobile-alt ka-slideshow-icon" style="cursor: pointer;" aria-hidden="true"
                                        matTooltip="{{profile?.primarynumber}}" (click)="showDetails(profile?.primarynumber)" [ngStyle] ="{'color':profile['cNumberVerStatus'] != null &&  profile['cNumberVerStatus'] === true?'green':'black'}"></i>
                                    </span>
                                    <span *ngIf="profile['cNumberVerStatus']===null || profile['cNumberVerStatus']===false"
                                        class="ka-em-mobile-email">
                                         <span class="ka-em-profileId"
                                            (click)="verifyMobileNumber(profile['cust_ID'],profile['primarynumber'])"><i class="far fa-times-circle ka-slideshow-icon" matTooltip="Not Verified" style="color: red;"></i></span>
                                    </span>
                                    <span *ngIf="profile['cNumberVerStatus']!=null &&  profile['cNumberVerStatus']===true"
                                        style="color: green;" class="ka-em-mobile-email" matTooltip="Verified"><i
                                            class="far fa-check-circle ka-slideshow-icon"></i></span>
                                            <span (click)="getOfficePurposeData(profile.cust_ID)"
                                            *ngIf="profile.Gender === 'Male'" style="font-size: 18px;cursor: pointer;padding-left: 10px;" [ngClass]="{'ka-em-officePurposeGroom': profile.isAboutProfile}">
                                              <i class="fas fa-comment"></i></span>
                                              <span (click)="getOfficePurposeData(profile.cust_ID)"
                                            *ngIf="profile.Gender === 'Female'" style="font-size: 18px;cursor: pointer;padding-left: 10px;" [ngClass]="{'ka-em-officePurposeBride': profile.isAboutProfile}">
                                              <i class="fas fa-comment"></i></span>
                                
                            </div>
                            </div>                        
                                
                            
                        </div>
                        <div class="ka-em-slideOwnerDetails px-4" *ngIf="!AssignOwner">
                            <div class="row" *ngIf="profile['profileOwnername'] !== null">
                                <span class="ka-ownerLabel  col-4">Profile Owner </span> 
                                <span class="col-8"> : {{profile['profileOwnername']}}
                                    <span> - {{profile['PrimaryOwnerNumber']}}</span>
                                </span>
                            </div>
                            <div class="row" *ngIf="profile['SecondaryProfileOwnerName'] !== null">
                                <span class="ka-ownerLabel  col-4">Secondary Owner  </span>                                          
                                <span class="col-8"> : {{profile['SecondaryProfileOwnerName']}}
                                    <span> - {{profile['SecondaryProfileOwnerNumber']}}</span>
                                </span> 
                            </div>                                   
                        </div>
                        <div class="top-section pl-3 pr-3 pt-1 pb-1">
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">DOR</div> :
                                <div class="col font-weight-bold">
                                    {{profile['DOR']}}
                                </div>
                                
                            </div>
                            <!-- <div class="row">
                                <div class="col ka-em-slide-content-label">Education Grade</div> :
                                <div class="col font-weight-bold">
                                    {{profile['EducationGrade']}}
                                </div>
                                
                            </div> -->
                            <!-- <div class="row">
                                <div class="col ka-em-slide-content-label">Payment Offer</div> :
                                <div class="col font-weight-bold">
                                    <span style="color: #06347e; cursor: pointer;" (click)="navigateToViewOffers(profile?.profileID)" *ngIf="profile?.offerStatus === 1;else viewOffer">View Offers</span>
                                    <ng-template #viewOffer>
                                        <span *ngIf="loginData['isAdmin'] === 1" style="color: red; cursor: pointer;" (click)="openPaymentOffer(profile)">Create Offer</span>
                                        <span *ngIf="loginData['isAdmin'] !== 1" style="color: red;">Create Offer</span>
                                    </ng-template>
                                </div>
                                
                            </div> -->
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Last Login</div> :
    
                                <div class="col font-weight-bold"
                                    *ngIf="profile['lastLoginDate']!=null && profile['lastLoginDate']!='' && profile['lastLoginDate']!=undefined">
                                    <span>{{profile['lastLoginDate']}}</span>
                                </div>
                                <div class="col ka-em-profileId"
                                    *ngIf="(profile['lastLoginDate']===null || profile['lastLoginDate']==='' || profile['lastLoginDate']===undefined)">
                                    <span (click)="forgotPassword(profile['profileID'])">
                                        Forgot Password
                                    </span>
                                </div>
                                
    
                            </div>
                            <!-- <div class="row">
                                <div class="col ka-em-slide-content-label">Mobile Last Login</div> :
    
                                <div class="col font-weight-bold"
                                    *ngIf="profile['LastMobileLoginDate']!=null && profile['LastMobileLoginDate']!='' && profile['LastMobileLoginDate']!=undefined">
                                    <span>{{profile['LastMobileLoginDate']}}</span>
                                </div>
                                <div class="col ka-em-profileId"
                                    *ngIf="(profile['LastMobileLoginDate']===null || profile['LastMobileLoginDate']==='' || profile['LastMobileLoginDate']===undefined)">
                                    <span (click)="forgotPassword(profile['profileID'])">
                                        Forgot Password
                                    </span>
                                </div>
                                
    
                            </div> -->
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Send/Recv</div> :
                                <div class="col font-weight-bold">
                                    <span *ngIf="profile['srCount']!=null" class="ka-em-profileId"
                                        (click)="navigateToCommunicationLog(profile['profileID'])">
                                        {{profile['srCount']}}
                                    </span>
                                    <span style="color: red;" *ngIf="profile['srCount']===null">No Service</span>
    
                                </div>
                                
    
                            </div>
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Payment</div> :
                                <div class="col font-weight-bold">
                                    <span *ngIf="profile['paidAmount']!=null && profile['paidAmount']!=''"
                                        class="ka-em-profileId" (click)="navigateToPaymentPage(profile['profileID'])">{{profile['paidAmount']}} ({{profile['paymentDate']}})</span>
                                    <span style="color: red;" *ngIf="profile['paidAmount']===null || profile['paidAmount']===''">Not
                                        Paid</span>
                                </div>
                                
    
    
                            </div>
                            <div class="row" [hidden]="profile['expiryDate'] == null || profile['expiryDate'] == ''">
                                <div class="col-4 ka-em-slide-content-label">Expired Date</div> :
                                <div class="col font-weight-bold">
                                    <span style="color: red; cursor: pointer;" (click)="navigateToPaymentPage(profile['profileID'])">{{profile['expiryDate']}} ({{profile['points']}})</span>
                                </div>
                                
    
                            </div>
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Marketing Ticket</div> :
                                <div class="col font-weight-bold">
                                    <span class="ka-em-profileId"
                                        (click)="viewMarketingTicket(profile['Emp_Ticket_ID'])">{{profile['ticketID']}}
                                    </span>
                                    <span> ({{profile['profileOwnername']}} - {{profile['empUserName']}})</span> ({{profile?.NoofDays === 1 ? (profile?.NoofDays + ' day') : (profile?.NoofDays + ' days')}})
    
                                </div>
                                
    
                            </div>
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Match Meetings</div> :
                                <div class="col font-weight-bold">
                                    <span class="ka-em-profileId"
                                        (click)="navigateToCommunicationLog(profile['profileID'])">
                                        {{profile['matchMeetingCount']}}
                                    </span>
                                </div>
                                
    
                            </div>
                            <!-- <div class="row">
                                <div class="col-4 ka-em-slide-content-label">SA Form</div> :
                                <div class="col font-weight-bold">
                                    <span style="color: #06347e;" *ngIf="profile['saForm']!=null" (click)="viewSAForm(profile['saForm'])"
                                        class="ka-em-profileId">View SA
                                        Form</span>
                                    <span style="color: red;" *ngIf="profile['saForm']===null"
                                        (click)="uploadSAForm(profile['profileID'])" class="ka-em-SAForm">Upload SA
                                        Form</span>
    
                                </div>
                                
    
                            </div> -->
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Last Service Date</div> :
                                <div class="col font-weight-bold">
                                    <span>{{profile['lastService_Date']}}</span>
                                </div>
                                
    
                            </div>
                            <!-- <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Website/Mobile Login Count</div> :
                                <div class="col font-weight-bold">
                                    <span>{{profile['websiteLoginCount']}} / {{profile['mobileLoginCount']}}</span>
                                </div>
                                
    
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="mode==='ACII'">
                    <div class="col-md-6" style="padding: 30px;">
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">ProfileId</div> :
                            <div class="col">
                                <span style="cursor: pointer;">
                                    <i class="fa  fa-clipboard" (click)="copyProfileId(profile['profileID'])"
                                        aria-hidden="true"></i>
                                </span>
                                <span (click)="copyProfileId(profile['profileID'])" *ngIf="mode==='ACII'"
                                    class="ka-em-profileId"(click)="navigateToViewProfileByProfileId(profile['profileID'])"
                                    [ngStyle]="{'color':getAssignTktColour(profile['paidSatus'])}">{{getProfileTypeWithProfileID(profile)}}
                                    <span *ngIf="profile?.BrokerCode != null">({{profile?.BrokerCode}})</span>
                                    <span *ngIf="profile?.branchCode != null" style="color: rgb(173, 102, 240);"> - {{profile?.branchCode}}</span>
                                </span>
                                <span *ngIf="profile?.KMPLID != null"> - {{profile?.KMPLID}}</span>
                            </div>
                            <div class="col-md-2">
                                <img (click)="naviagteToHoroscope(profile['horoScopeImage'])"
                                    *ngIf="profile['horoscopeStatus'] === 1"
                                    src="../../../../assets/img/dashboard/ico_horoscope.jpg"
                                    style=" width: 30% !important;height: 20px !important; padding: 0px !important;cursor: pointer;margin-left: -86%;">

                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Name</div> :
                            <div class="col font-weight-bold">
                                {{profile['lastName']}} {{profile['firstName']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">DOB(Age)</div> :
                            <div class="col font-weight-bold">
                                {{profile['dob']}}({{profile['age']}})
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Height</div> :
                            <div class="col font-weight-bold">
                                {{profile['height']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">TOB(Star)</div> :
                            <div class="col font-weight-bold">
                                {{profile['tob']}}({{profile['star']}})
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Place of birth</div> :
                            <div class="col font-weight-bold">
                                {{profile['placeOfBirth']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Gothram</div> :
                            <div class="col font-weight-bold">
                                {{profile['gothram']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Caste</div> :
                            <div class="col font-weight-bold">
                                {{profile['motherTongue']}} - {{profile['caste']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Marital Status</div> :
                            <div class="col font-weight-bold">
                                {{profile['maritalStatus']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Qualification</div> :
                            <div class="col font-weight-bold">
                                {{profile['qualification']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Education Category</div> :
                            <div class="col font-weight-bold">
                                {{profile['educationGroup']}} 
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Profession</div> :
                            <div class="col font-weight-bold">
                                {{profile['profession']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Job Location</div> :
                            <div class="col font-weight-bold">
                                {{profile['jobLocation']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Income(P.M)</div> :
                            <div class="col font-weight-bold">
                                {{profile['income']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Father/Mother Native</div> :
                            <div class="col font-weight-bold">
                                {{profile['ffNative']}} / {{profile['mfNative']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Property</div> :
                            <div class="col font-weight-bold">
                                {{profile['property']}} <span *ngIf="profile?.property != null">({{profile['propertyType']}})</span>
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                      
                    </div>
                    <div class="col-md-6">
                        <div class="row ka-slideShow-image">
                            <img src="{{profile['applicationPhotoPath']}}" class="myprofile-img"
                                (click)="getUserPhotoGal(profile['applicationPhotoPath'],profile['cust_ID'])"
                                style="cursor: pointer;">
                        </div>
                        <div class="row" style="justify-content: center;">
                            <span *ngIf="profile['photoCount']===0" class="ka-em-photo-count"
                                (click)="photoRequest(profile['profileID'])">Photo
                                Request</span>
                            <span *ngIf="profile['photoCount']>0">No Of Photos:
                                {{profile['photoCount']}}</span>

                        </div>
                        <div class="container">
                            <div class="row d-flex justify-content-center">                                
                                <div class="col p-1 ml-5 d-flex justify-content-end">                                    
                                    <span style="padding-left: 1%;">
                                        <i class="far fa-solid fa-envelope ka-slideshow-icon" style="cursor: pointer;" aria-hidden="true"
                                        matTooltip="{{profile?.primaryemail}}" (click)="showDetails(profile?.primaryemail)" [ngStyle] ="{'color':profile['cEmailVerStatus']!=null &&  profile['cEmailVerStatus']===true?'green':'black'}"></i>
                                    </span>
                                    <span *ngIf="profile['cEmailVerStatus']===null || profile['cEmailVerStatus']===false"
                                        class="ka-em-mobile-email">
                                         <span class="ka-em-profileId"
                                            (click)="verifyEmail(profile['cust_ID'])"><i class="far fa-times-circle ka-slideshow-icon" matTooltip="Not Verified" style="color: red;"></i></span>
                                    </span>
                                    <span *ngIf="profile['cEmailVerStatus']!=null &&  profile['cEmailVerStatus']===true"
                                        style="color: green;" class="ka-em-mobile-email"><i
                                            class="far fa-check-circle ka-slideshow-icon" matTooltip="Verified"></i></span>
                                </div>
                                <div class="col p-1 mr-5">                                    
                                    <span style="padding-left: 1%;">
                                        <i class="fas fa-mobile-alt ka-slideshow-icon" style="cursor: pointer;" aria-hidden="true"
                                        matTooltip="{{profile?.primarynumber}}" (click)="showDetails(profile?.primarynumber)" [ngStyle] ="{'color':profile['cNumberVerStatus'] != null &&  profile['cNumberVerStatus'] === true?'green':'black'}"></i>
                                    </span>
                                    <span *ngIf="profile['cNumberVerStatus']===null || profile['cNumberVerStatus']===false"
                                        class="ka-em-mobile-email">
                                         <span class="ka-em-profileId"
                                            (click)="verifyMobileNumber(profile['cust_ID'],profile['primarynumber'])"><i class="far fa-times-circle ka-slideshow-icon" matTooltip="Not Verified" style="color: red;"></i></span>
                                    </span>
                                    <span *ngIf="profile['cNumberVerStatus']!=null &&  profile['cNumberVerStatus']===true"
                                        style="color: green;" class="ka-em-mobile-email" matTooltip="Verified"><i
                                            class="far fa-check-circle ka-slideshow-icon"></i></span>
                                            <span (click)="getOfficePurposeData(profile.cust_ID)"
                                            *ngIf="profile.gender === 'Male'" style="font-size: 18px;cursor: pointer;padding-left: 10px;" [ngClass]="{'ka-em-officePurposeGroom': profile.isAboutProfile}">
                                              <i class="fas fa-comment"></i></span>
                                              <span (click)="getOfficePurposeData(profile.cust_ID)"
                                            *ngIf="profile.gender === 'Female'" style="font-size: 18px;cursor: pointer;padding-left: 10px;" [ngClass]="{'ka-em-officePurposeBride': profile.isAboutProfile}">
                                              <i class="fas fa-comment"></i></span>
                                
                            </div>
                            </div>                        
                                
                            
                        </div>
                        <div class="ka-em-slideOwnerDetails px-4" *ngIf="!AssignOwner">
                            <div class="row" *ngIf="profile['primaryOwnerName'] !== null">
                                <span class="ka-ownerLabel  col-4">Profile Owner </span> 
                                <span class="col-8"> : {{profile['primaryOwnerName']}}
                                    <span> - {{profile['primaryOwnerNumber']}}</span>
                                </span>
                            </div>
                            <div class="row" *ngIf="profile['secondaryProfileOwnerName'] !== null">
                                <span class="ka-ownerLabel  col-4">Secondary Owner  </span>                                          
                                <span class="col-8"> : {{profile['secondaryProfileOwnerName']}}
                                    <span> - {{profile['secondaryProfileOwnerNumber']}}</span>
                                </span> 
                            </div>                                   
                        </div>
                        <div class="top-section pl-3 pr-3 pt-1 pb-1">
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">DOR</div> :
                                <div class="col font-weight-bold">
                                    {{profile['dor']}}
                                </div>
                                
                            </div>
                            <!-- <div class="row">
                                <div class="col ka-em-slide-content-label">Education Grade</div> :
                                <div class="col font-weight-bold">
                                    {{profile['EducationGrade']}}
                                </div>
                                
                            </div> -->
                            <!-- <div class="row">
                                <div class="col ka-em-slide-content-label">Payment Offer</div> :
                                <div class="col font-weight-bold">
                                    <span style="color: #06347e; cursor: pointer;" (click)="navigateToViewOffers(profile?.profileID)" *ngIf="profile?.offerStatus === 1;else viewOffer">View Offers</span>
                                    <ng-template #viewOffer>
                                        <span *ngIf="loginData['isAdmin'] === 1" style="color: red; cursor: pointer;" (click)="openPaymentOffer(profile)">Create Offer</span>
                                        <span *ngIf="loginData['isAdmin'] !== 1" style="color: red;">Create Offer</span>
                                    </ng-template>
                                </div>
                                
                            </div> -->
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Last Login</div> :
    
                                <div class="col font-weight-bold"
                                    *ngIf="profile['lastLoginDate']!=null && profile['lastLoginDate']!='' && profile['lastLoginDate']!=undefined">
                                    <span>{{profile['lastLoginDate']}}</span>
                                </div>
                                <div class="col ka-em-profileId"
                                    *ngIf="(profile['lastLoginDate']===null || profile['lastLoginDate']==='' || profile['lastLoginDate']===undefined)">
                                    <span (click)="forgotPassword(profile['profileID'])">
                                        Forgot Password
                                    </span>
                                </div>
                                
    
                            </div>
                            <!-- <div class="row">
                                <div class="col ka-em-slide-content-label">Mobile Last Login</div> :
    
                                <div class="col font-weight-bold"
                                    *ngIf="profile['LastMobileLoginDate']!=null && profile['LastMobileLoginDate']!='' && profile['LastMobileLoginDate']!=undefined">
                                    <span>{{profile['LastMobileLoginDate']}}</span>
                                </div>
                                <div class="col ka-em-profileId"
                                    *ngIf="(profile['LastMobileLoginDate']===null || profile['LastMobileLoginDate']==='' || profile['LastMobileLoginDate']===undefined)">
                                    <span (click)="forgotPassword(profile['profileID'])">
                                        Forgot Password
                                    </span>
                                </div>
                                
    
                            </div> -->
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Send/Recv</div> :
                                <div class="col font-weight-bold">
                                    <span *ngIf="profile['srCount']!=null" class="ka-em-profileId"
                                        (click)="navigateToCommunicationLog(profile['profileID'])">
                                        {{profile['srCount']}}
                                    </span>
                                    <span style="color: red;" *ngIf="profile['srCount']===null">No Service</span>
    
                                </div>
                                
    
                            </div>
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Payment</div> :
                                <div class="col font-weight-bold">
                                    <span *ngIf="profile['paidAmount']!=null && profile['paidAmount']!=''"
                                        class="ka-em-profileId" (click)="navigateToPaymentPage(profile['profileID'])">{{profile['paidAmount']}} ({{profile['paymentDate']}})</span>
                                    <span style="color: red;" *ngIf="profile['paidAmount']===null || profile['paidAmount']===''">Not
                                        Paid</span>
                                </div>
                                
    
    
                            </div>
                            <div class="row" [hidden]="profile['expiryDate'] == null || profile['expiryDate'] == ''">
                                <div class="col-4 ka-em-slide-content-label">Expired Date</div> :
                                <div class="col font-weight-bold">
                                    <span style="color: red; cursor: pointer;" (click)="navigateToPaymentPage(profile['profileID'])">{{profile['expiryDate']}} ({{profile['points']}})</span>
                                </div>
                                
    
                            </div>
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Marketing Ticket</div> :
                                <div class="col font-weight-bold">
                                    <span class="ka-em-profileId"
                                        (click)="viewMarketingTicket(profile['emp_Ticket_ID'])">{{profile['ticketID']}}
                                    </span>
                                    <span> ({{profile['profileOwnerName']}} - {{profile['empUserName']}})</span> ({{profile?.noofDays === 1 ? (profile?.noofDays + ' day') : (profile?.noofDays + ' days')}})
    
                                </div>
                                
    
                            </div>
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Match Meetings</div> :
                                <div class="col font-weight-bold">
                                    <span class="ka-em-profileId"
                                        (click)="navigateToCommunicationLog(profile['profileID'])">
                                        {{profile['matchMeetingCount']}}
                                    </span>
                                </div>
                                
    
                            </div>
                            <!-- <div class="row">
                                <div class="col-4 ka-em-slide-content-label">SA Form</div> :
                                <div class="col font-weight-bold">
                                    <span style="color: #06347e;" *ngIf="profile['saForm']!=null" (click)="viewSAForm(profile['saForm'])"
                                        class="ka-em-profileId">View SA
                                        Form</span>
                                    <span style="color: red;" *ngIf="profile['saForm']===null"
                                        (click)="uploadSAForm(profile['profileID'])" class="ka-em-SAForm">Upload SA
                                        Form</span>
    
                                </div>
                                
    
                            </div> -->
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Last Service Date</div> :
                                <div class="col font-weight-bold">
                                    <span>{{profile['lastService_Date']}}</span>
                                </div>
                                
    
                            </div>
                            <!-- <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Website/Mobile Login Count</div> :
                                <div class="col font-weight-bold">
                                    <span>{{profile['websiteLoginCount']}} / {{profile['mobileLoginCount']}}</span>
                                </div>
                                
    
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="mode==='assign'">
                    <div class="col-md-6" style="padding: 30px;">
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">ProfileId</div> :
                            <div class="col">
                                <span style="cursor: pointer;">
                                    <i class="fa  fa-clipboard" (click)="copyProfileId(profile['ProfileID'])"
                                        aria-hidden="true"></i>
                                </span>
                                <span (click)="copyProfileId(profile['profileID'])" *ngIf="mode==='assign'"
                                    class="ka-em-profileId"(click)="navigateToViewProfileByProfileId(profile['ProfileID'])"
                                    [ngStyle]="{'color':getAssignTktColour(profile['paidSatus'])}">{{getProfileTypeAssign(profile)}}
                                    <span *ngIf="profile?.BrokerCode != null">({{profile?.BrokerCode}})</span>
                                </span>
                                <span *ngIf="profile?.BranchCode != null" style="color: rgb(173, 102, 240);"> - {{profile?.BranchCode}}</span>
                            </div>
                            <div class="col-md-2">
                                <img (click)="naviagteToHoroscope(profile['horoScopeImage'])"
                                    *ngIf="profile['horoscopeStatus'] === 1"
                                    src="../../../../assets/img/dashboard/ico_horoscope.jpg"
                                    style=" width: 30% !important;height: 20px !important; padding: 0px !important;cursor: pointer;margin-left: -86%;">

                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Name</div> :
                            <div class="col font-weight-bold">
                                {{profile['lastName']}} {{profile['firstName']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">DOB(Age)</div> :
                            <div class="col font-weight-bold">
                                {{profile['DOB']}}({{profile['Age']}})
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Height</div> :
                            <div class="col font-weight-bold">
                                {{profile['Height']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">TOB(Star)</div> :
                            <div class="col font-weight-bold">
                                {{profile['TOB']}}({{profile['Star']}})
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Place of birth</div> :
                            <div class="col font-weight-bold">
                                {{profile['PlaceOfBirth']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Gothram</div> :
                            <div class="col font-weight-bold">
                                {{profile['Gothram']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Caste</div> :
                            <div class="col font-weight-bold">
                                {{profile['mothertongue']}} - {{profile['Caste']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Marital Status</div> :
                            <div class="col font-weight-bold">
                                {{profile['MaritalStatus']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Qualification</div> :
                            <div class="col font-weight-bold">
                                {{profile['qualification']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Education Category</div> :
                            <div class="col font-weight-bold">
                                {{profile['EducationCategory']}} 
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Profession</div> :
                            <div class="col font-weight-bold">
                                {{profile['Profession']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Job Location</div> :
                            <div class="col font-weight-bold">
                                {{profile['JobLocation']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Income(P.M)</div> :
                            <div class="col font-weight-bold">
                                {{profile['Income']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Father/Mother Native</div> :
                            <div class="col font-weight-bold">
                                {{profile['FFNative']}} / {{profile['MFNative']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Property</div> :
                            <div class="col font-weight-bold">
                                {{profile['Property']}} <span *ngIf="profile?.Property != null">({{profile['PropertyType']}})</span>
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label font-weight-bold  " [ngStyle]="{'color': profile['InterestedInIntercaste'] === true ? '#a326bc' : 'black'}">Caste No Bar</div> :
                            <div class="col font-weight-bold" [ngStyle]="{'color': profile['InterestedInIntercaste'] === true ? '#a326bc' : 'black'}">
                                {{profile['InterestedInIntercaste'] === true ? 'Yes' : 'No'}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>


                      
                    </div>
                    <div class="col-md-6">
                        <div class="row ka-slideShow-image">
                            <img src="{{profile['ApplicationPhotoPath']}}" class="myprofile-img"
                                (click)="getUserPhotoGal(profile['ApplicationPhotoPath'],profile['cust_id'])"
                                style="cursor: pointer;">
                        </div>
                        <div class="row" style="justify-content: center;">
                            <span *ngIf="profile['photoCount']===0" class="ka-em-photo-count"
                                (click)="photoRequest(profile['profileID'])">Photo
                                Request</span>
                            <span *ngIf="profile['photoCount']>0">No Of Photos:
                                {{profile['photoCount']}}</span>

                        </div>
                        <div class="container">
                            <div class="row d-flex justify-content-center">                                
                                <div class="col p-1 ml-5 d-flex justify-content-end">                                    
                                    <span style="padding-left: 1%;">
                                        <i class="far fa-solid fa-envelope ka-slideshow-icon" style="cursor: pointer;" aria-hidden="true"
                                        matTooltip="{{profile?.primaryemail}}" (click)="showDetails(profile?.primaryemail)" [ngStyle] ="{'color':profile['cEmailVerStatus']!=null &&  profile['cEmailVerStatus']===true?'green':'black'}"></i>
                                    </span>
                                    <span *ngIf="profile['cEmailVerStatus']===null || profile['cEmailVerStatus']===false"
                                        class="ka-em-mobile-email">
                                         <span class="ka-em-profileId"
                                            (click)="verifyEmail(profile['cust_id'])"><i class="far fa-times-circle ka-slideshow-icon" matTooltip="Not Verified" style="color: red;"></i></span>
                                    </span>
                                    <span *ngIf="profile['cEmailVerStatus']!=null &&  profile['cEmailVerStatus']===true"
                                        style="color: green;" class="ka-em-mobile-email"><i
                                            class="far fa-check-circle ka-slideshow-icon" matTooltip="Verified"></i></span>
                                </div>
                                <div class="col p-1 mr-5">                                    
                                    <span style="padding-left: 1%;">
                                        <i class="fas fa-mobile-alt ka-slideshow-icon" style="cursor: pointer;" aria-hidden="true"
                                        matTooltip="{{profile?.primarynumber}}" (click)="showDetails(profile?.primarynumber)" [ngStyle] ="{'color':profile['cNumberVerStatus'] != null &&  profile['cNumberVerStatus'] === true?'green':'black'}"></i>
                                    </span>
                                    <span *ngIf="profile['cNumberVerStatus']===null || profile['cNumberVerStatus']===false"
                                        class="ka-em-mobile-email">
                                         <span class="ka-em-profileId"
                                            (click)="verifyMobileNumber(profile['cust_id'],profile['primarynumber'])"><i class="far fa-times-circle ka-slideshow-icon" matTooltip="Not Verified" style="color: red;"></i></span>
                                    </span>
                                    <span *ngIf="profile['cNumberVerStatus']!=null &&  profile['cNumberVerStatus']===true"
                                        style="color: green;" class="ka-em-mobile-email" matTooltip="Verified"><i
                                            class="far fa-check-circle ka-slideshow-icon"></i></span>
                                            <span (click)="getOfficePurposeData(profile.cust_id)"
                                            *ngIf="profile.Gender === 'Male'" style="font-size: 18px;cursor: pointer;padding-left: 10px;" [ngClass]="{'ka-em-officePurposeGroom': profile.isAboutProfile}">
                                              <i class="fas fa-comment"></i></span>
                                              <span (click)="getOfficePurposeData(profile.cust_id)"
                                            *ngIf="profile.Gender === 'Female'" style="font-size: 18px;cursor: pointer;padding-left: 10px;" [ngClass]="{'ka-em-officePurposeBride': profile.isAboutProfile}">
                                              <i class="fas fa-comment"></i></span>
                                
                            </div>
                            </div>                        
                                
                            
                        </div>
                        <div class="ka-em-slideOwnerDetails px-4" *ngIf="!AssignOwner">
                            <div class="row" *ngIf="profile['profileOwnername'] !== null">
                                <span class="ka-ownerLabel  col-4">Profile Owner </span> 
                                <span class="col-8"> : {{profile['profileOwnername']}}
                                    <span> - {{profile['PrimaryOwnerNumber']}}</span>
                                </span>
                            </div>
                            <div class="row" *ngIf="profile['SecondaryProfileOwnerName'] !== null">
                                <span class="ka-ownerLabel  col-4">Secondary Owner  </span>                                          
                                <span class="col-8"> : {{profile['SecondaryProfileOwnerName']}}
                                    <span> - {{profile['SecondaryProfileOwnerNumber']}}</span>
                                </span> 
                            </div>                                   
                        </div>
                        <div class="top-section pl-3 pr-3 pt-1 pb-1">
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">DOR</div> :
                                <div class="col font-weight-bold">
                                    {{profile['DOR']}}
                                </div>
                                
                            </div>
                            <!-- <div class="row">
                                <div class="col ka-em-slide-content-label">Education Grade</div> :
                                <div class="col font-weight-bold">
                                    {{profile['EducationGrade']}}
                                </div>
                                
                            </div> -->
                            <!-- <div class="row">
                                <div class="col ka-em-slide-content-label">Payment Offer</div> :
                                <div class="col font-weight-bold">
                                    <span style="color: #06347e; cursor: pointer;" (click)="navigateToViewOffers(profile?.profileID)" *ngIf="profile?.offerStatus === 1;else viewOffer">View Offers</span>
                                    <ng-template #viewOffer>
                                        <span *ngIf="loginData['isAdmin'] === 1" style="color: red; cursor: pointer;" (click)="openPaymentOffer(profile)">Create Offer</span>
                                        <span *ngIf="loginData['isAdmin'] !== 1" style="color: red;">Create Offer</span>
                                    </ng-template>
                                </div>
                                
                            </div> -->
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Last Login</div> :
    
                                <div class="col font-weight-bold"
                                    *ngIf="profile['lastLoginDate']!=null && profile['lastLoginDate']!='' && profile['lastLoginDate']!=undefined">
                                    <span>{{profile['lastLoginDate']}}</span>
                                </div>
                                <div class="col ka-em-profileId"
                                    *ngIf="(profile['lastLoginDate']===null || profile['lastLoginDate']==='' || profile['lastLoginDate']===undefined)">
                                    <span (click)="forgotPassword(profile['profileID'])">
                                        Forgot Password
                                    </span>
                                </div>
                                
    
                            </div>
                            <!-- <div class="row">
                                <div class="col ka-em-slide-content-label">Mobile Last Login</div> :
    
                                <div class="col font-weight-bold"
                                    *ngIf="profile['LastMobileLoginDate']!=null && profile['LastMobileLoginDate']!='' && profile['LastMobileLoginDate']!=undefined">
                                    <span>{{profile['LastMobileLoginDate']}}</span>
                                </div>
                                <div class="col ka-em-profileId"
                                    *ngIf="(profile['LastMobileLoginDate']===null || profile['LastMobileLoginDate']==='' || profile['LastMobileLoginDate']===undefined)">
                                    <span (click)="forgotPassword(profile['profileID'])">
                                        Forgot Password
                                    </span>
                                </div>
                                
    
                            </div> -->
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Send/Recv</div> :
                                <div class="col font-weight-bold">
                                    <span *ngIf="profile['srCount']!=null" class="ka-em-profileId"
                                        (click)="navigateToCommunicationLog(profile['profileID'])">
                                        {{profile['srCount']}}
                                    </span>
                                    <span style="color: red;" *ngIf="profile['srCount']===null">No Service</span>
    
                                </div>
                                
    
                            </div>
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Offer</div> :
                                <div class="col font-weight-bold">
                                    <span *ngIf="profile['IsMembershipOffer'] === 1"
                                        class="ka-em-profileId" (click)="redirectToOffers(profile['ProfileID'])"> View Offer</span>
                                    <span style="color: red;" *ngIf="profile['IsMembershipOffer'] !== 1" (click)="redirectToOffers(profile['ProfileID'])">Create
                                        Offer</span>
                                </div>
                                
    
    
                            </div>
                            <div class="row" [hidden]="profile['expiryDate'] == null || profile['expiryDate'] == ''">
                                <div class="col-4 ka-em-slide-content-label">Expired Date</div> :
                                <div class="col font-weight-bold">
                                    <span style="color: red; cursor: pointer;" (click)="navigateToPaymentPage(profile['profileID'])">{{profile['expiryDate']}} ({{profile['points']}})</span>
                                </div>
                                
    
                            </div>
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Marketing Ticket</div> :
                                <div class="col font-weight-bold">
                                    <span class="ka-em-profileId"
                                        (click)="viewMarketingTicket(profile['Emp_Ticket_ID'])">{{profile['TicketID']}}
                                    </span>
                                    <span> ({{profile['ProfileOwner']}})</span> ({{profile?.NoofDays === 1 ? (profile?.NoofDays + ' day') : (profile?.NoofDays + ' days')}})
    
                                </div>
                                
    
                            </div>
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Match Meetings</div> :
                                <div class="col font-weight-bold">
                                    <span class="ka-em-profileId"
                                        (click)="navigateToCommunicationLog(profile['profileID'])">
                                        {{profile['matchMeetingCount']}}
                                    </span>
                                </div>
                                
    
                            </div>
                            <!-- <div class="row">
                                <div class="col-4 ka-em-slide-content-label">SA Form</div> :
                                <div class="col font-weight-bold">
                                    <span style="color: #06347e;" *ngIf="profile['saForm']!=null" (click)="viewSAForm(profile['saForm'])"
                                        class="ka-em-profileId">View SA
                                        Form</span>
                                    <span style="color: red;" *ngIf="profile['saForm']===null"
                                        (click)="uploadSAForm(profile['profileID'])" class="ka-em-SAForm">Upload SA
                                        Form</span>
    
                                </div>
                                
    
                            </div> -->
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Last Service Date</div> :
                                <div class="col font-weight-bold">
                                    <span>{{profile['lastService_Date']}}</span>
                                </div>
                                
    
                            </div>
                            <!-- <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Website/Mobile Login Count</div> :
                                <div class="col font-weight-bold">
                                    <span>{{profile['websiteLoginCount']}} / {{profile['mobileLoginCount']}}</span>
                                </div>
                                
    
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="ka-em-assignProfile container" *ngIf="AssignOwner">
                    <form class="" [formGroup]="assignProfileForm" (ngSubmit)="assignOwner(profile)">
                        <div class="ka-slideAssign my-3">Assign Profile</div>
                        <div class="row d-flex justify-content-between">
                            <div class="col">
                                <div class="ka-em-slideLabel">Service Type</div>
                                <ng-multiselect-dropdown  [placeholder]="'Select'" formControlName="serviceType" [settings]="dropDownSettings" class="col-3 p-0 populate-top"
                                [data]="profileTypeArray" (onSelect)="getProfileOwners($event)">
                              </ng-multiselect-dropdown>
                            </div>
                            <div class="col">
                                <div class="ka-em-slideLabel">Profile Owner</div>
                                <ng-multiselect-dropdown [placeholder]="'Select'" formControlName="primaryOwner" [settings]="dropDownSettings" class="col-3 p-0 populate-top"
                                [data]="profileOwnerArray" (onSelect)="onSelectProfileOwner($event)">
                                </ng-multiselect-dropdown>
                            </div>
                            <div class="col">
                                <div class="ka-em-slideLabel">Secondary Owner</div>
                                <ng-multiselect-dropdown [placeholder]="'Select'" formControlName="secondaryOwner" [settings]="dropDownSettings" class="col-3 p-0 populate-top"
                                [data]="profileOwnerArray" (onSelect)="onSelectSecondaryOwner($event)">
                              </ng-multiselect-dropdown>
                            </div>
                            <!-- <div class="col d-flex justify-content-center align-items-center flex-column" *ngIf="displayNX">
                                <p class="ka-em-slideLabel">NX-Grade</p>
                                <p>
                                    <mat-checkbox formControlName="nxGrade">N-Exclusive</mat-checkbox>
                                </p>
                            </div>    -->
                            <div class="col d-flex justify-content-center">
                                <button class="load-more btn" type="submit" [disabled]="assignProfileForm.invalid">ASSIGN NOW</button>
                            </div>
                        </div>                                       
                    </form>
                </div>

                <div class="row ka-em-footer" *ngIf="mode!=='myProfile'">

                    <div class="col-md-12 ka-em-footer-content">
                        <!-- <a class="dropdown-item waves-light" mdbWavesEffect>Edit Partner Preferences</a>
                                <span> | </span>
                                <a class="dropdown-item waves-light" mdbWavesEffect>General Search</a>
                                <span> | </span>
                                <a class="dropdown-item waves-light" mdbWavesEffect>Advanced Search</a>
                                <span> | </span> -->
                        <p class="footer-link" (click)="navigateToPartnerPrefarence(profile['cust_ID'])">Edit
                            Partner Preferences</p><span class="footer-divider">|</span>
                        <p class="footer-link" *ngIf="mode==='editView'"
                            (click)="navigateToSearch(profile['profileID'],'general')">General Search
                        </p>
                        <p class="footer-link" *ngIf="mode==='ACII'"
                            (click)="navigateToSearch(profile['profileID'],'general')">General Search
                        </p>
                        <p class="footer-link" *ngIf="mode==='assign'"
                        (click)="navigateToSearch(profile['ProfileID'],'general')">General Search
                        </p>
                        <p class="footer-link" *ngIf="mode==='dash'"
                            (click)="navigateToSearch(profile['profileID'],'general')">General Search
                        </p>
                        <p class="footer-link" *ngIf="mode==='profileValidation'"
                            (click)="navigateToSearch(profile['viewfullProfileID'],'general')">General Search
                        </p>
                        <span class="footer-divider">|</span>
                        <p class="footer-link" *ngIf="mode==='editView'"
                            (click)="navigateToSearch(profile['profileID'],'advanced')">Advanced Search
                        </p>
                        <p class="footer-link" *ngIf="mode==='ACII'"
                            (click)="navigateToSearch(profile['profileID'],'advanced')">Advanced Search
                        </p>
                        <p class="footer-link" *ngIf="mode==='dash'"
                        (click)="navigateToSearch(profile['profileID'],'advanced')">Advanced Search
                        </p>
                        <p class="footer-link" *ngIf="mode==='assign'"
                        (click)="navigateToSearch(profile['ProfileID'],'advanced')">Advanced Search
                        </p>
                        <p class="footer-link" *ngIf="mode==='profileValidation'"
                            (click)="navigateToSearch(profile['viewfullProfileID'],'advanced')">Advanced Search
                        </p><span class="footer-divider">|</span>
                        <p class="footer-link" (click)="navigateToRegistrationValidation()">Search By Contact
                        </p><span class="footer-divider">|</span>
                        <p class="footer-link">Delete Profile</p><span class="footer-divider">|</span>
                        <p class="footer-link" (click)="navigateToContact(profile['cust_ID'])">View Contacts</p>
                        <span class="footer-divider">|</span><br>
                        <p class="footer-link">My Profile</p>

                    </div>
                    <div class="col-md-12 ka-em-footer-content" style="justify-content: center;">
                        <span class="footer-divider">|</span>
                        <p class="footer-link" (click)="openMarketingSlideShow()">Marketing Slide Show</p><span
                            class="footer-divider">|</span>
                        <p class="footer-link" (click)="openMatchFowllowupSlideShow()">Followup Slide Show</p>
                        <span class="footer-divider">|</span>
                        <p class="footer-link">Create Remainder</p>
                    </div>


                </div>

                <div class="row ka-em-footer" *ngIf="mode==='myProfile'">

                    <div class="col-md-12 ka-em-footer-content">
                        <!-- <a class="dropdown-item waves-light" mdbWavesEffect>Edit Partner Preferences</a>
                                <span> | </span>
                                <a class="dropdown-item waves-light" mdbWavesEffect>General Search</a>
                                <span> | </span>
                                <a class="dropdown-item waves-light" mdbWavesEffect>Advanced Search</a>
                                <span> | </span> -->
                        <p class="footer-link" style="color: #06347e;" (click)="navigateToPartnerPrefarence(profile['cust_ID'])">Edit
                            Partner Preferences</p><span class="footer-divider">|</span>
                        <p class="footer-link" style="color: #06347e;" (click)="navigateToRegistrationValidation()">Search By Contact
                            </p><span class="footer-divider">|</span>
                        <p class="footer-link"style="color: #06347e;" (click)="navigateToContact(profile['cust_ID'])">View Contacts</p>
                            <span class="footer-divider">|</span><br>
                        <p class="footer-link" style="color: #06347e;"
                            (click)="navigateToSearch(profile['profileID'],'general')">General Search
                        </p>
                        <span class="footer-divider">|</span> 
                        <p class="footer-link" style="color: #06347e;"
                        (click)="navigateToSearch(profile['profileID'],'advanced')">Advanced Search
                        </p>
                        <span class="footer-divider">|</span>   
                        <p class="footer-link" style="color: #06347e;">Delete Profile</p><span class="footer-divider">|</span>
                        <p (click)="navigateToMyProfile(profile['profileID'])" class="footer-link" style="color: #06347e;">My Profile</p>

                    </div>
                    <div class="col-md-12 ka-em-footer-content" style="justify-content: center;">
                        <p class="footer-link" (click)="openMarketingSlideShow()">Marketing Slide Show</p><span
                            class="footer-divider">|</span>
                        <p class="footer-link" (click)="openMatchFowllowupSlideShow()">Followup Slide Show</p>
                        <span class="footer-divider">|</span>
                        <p class="footer-link">Create Remainder</p>
                    </div>


                </div>

            </div>
        </ngx-slick-carousel>
        <!-- <div class="col-md-12 text-center">
                    <span style="cursor: pointer;" (click)="activateSlideShow(isSlideShowActivated)"><img
                            *ngIf="isSlideShowActivated===false" src="../../../../assets/img/profile/slideshow_ic.svg"
                            alt="" style="height: 28px !important;"></span>
                    <span style="cursor: pointer;" (click)="activateSlideShow(isSlideShowActivated)"><img
                            *ngIf="isSlideShowActivated===true"
                            src="../../../../assets/img/profile/slideshowpauce_ic.svg" alt=""
                            style="height: 28px !important;"></span>
                </div> -->


    </div>

    <div class="no-records" *ngIf="slideShowData.length === 0">
        No Records Found
    </div>

</div>
    <!-- <div mdbModal #saFromUpload="mdbModal" class="modal fade" tabindex="-1" role="dialog"
        aria-labelledby="myBasicModalLabel" aria-hidden="true"
        [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
        <div class="modal-dialog modal-sm modal-dialog-centered" role="document">

            <div class="modal-content">
                <p style="text-align: center; font-weight: bold;">Upload SA Form</p>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="uploadSA.hide()"
                    style="top:-12px !important">
                    <span aria-hidden="true" class="">&times;</span>
                </button>
                <div class="row" style="justify-content: center;">
                    <input type="file" class="inputFile" #saFormInput id="saFormInput"
                        accept="image/png, image/jpeg,image/jpg" (change)="uploadSAFormImage($event)" />
                    <div *ngIf="isValidSAForm" class="error-msg">Please upload valid SA Form </div>
                </div>
                <div class="row">
                    <div class="col-md-6" style="left: 7px">
                        <div class="action-buttons">
                            <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                                mdbWavesEffect type="submit" [disabled]="isValidSAForm" (click)="submitSAForm()">Upload
                            </button>
                        </div>
                    </div>
                    <div class="col-md-6" style="top: 21px">
                        <p style="cursor: pointer;" (click)="clearField()"> <span>Cancel</span></p>
                    </div>


                </div>
            </div>
        </div>
    </div> -->

    <app-sa-form *ngIf="saFormPhotoPath" [saForm]="saFormPhotoPath"></app-sa-form>
    <view-ticket-modal [isModalShow]="modalBoolean" [ticketId]="ticketId" (closeTicketModal)="closeTicketModal($event)">
    </view-ticket-modal>
    <div mdbModal #successModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
        aria-labelledby="myBasicModalLabel" aria-hidden="true"
        [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
        <div class="modal-dialog modal-md modal-dialog-centered" role="document">

            <div class="modal-content">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="successModal.hide()">
                    <span aria-hidden="true" class="">&times;</span>
                </button>
                <div class="row text-left">

                    <!--Grid column-->
                    <div class="col-md-12 rmSectionPopup">
                        <div class="row p-2 m-2">

                            <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                                <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                                <p class="mt-2 p-0">{{responseMessage}} </p>

                                <div class="action-buttons">
                                    <button mdbBtn
                                        class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                                        mdbWavesEffect type="submit" (click)="successModal.hide()">ok
                                    </button>



                                </div>

                            </div>
                        </div>

                    </div>

                    <!--Grid column-->



                </div>
            </div>
        </div>
    </div>

    <div mdbModal #basicModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
        aria-labelledby="myBasicModalLabel" aria-hidden="true"
        [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
        <div class="modal-dialog modal-md" role="document">

            <div class="modal-content">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeOTPModal()">
                    <span aria-hidden="true" class="">&times;</span>
                </button>
                <div class="row text-left">

                    <!--Grid column-->
                    <div class="col-md-12 rmSectionPopup">
                        <div class="row p-2 m-2">

                            <div class="col-md-12 rmDetailsSectionPopup">
                                <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                                <p class="m-0 p-0">

                                    Mobile verification sent successfully to {{mobileNumber}}<br>

                                </p>

                                <div class="action-buttons" style="padding-top: 2%;">
                                    <div class="row">
                                        <div class="col-md-8" style="padding-top: 3%;">
                                            Check yes, If you want to verify by you
                                        </div>
                                        <div class="col-md-4" style="padding-top: 3%;">
                                            <div class="row">
                                                <div class="col">
                                                    <div class="btn-holder">
                                                        <input type="radio" class="ka-em-radio-btn" value="Yes" id="Yes"
                                                            name="radio"
                                                            (change)="isSeletedYesOrNo($event.target.value)"><label
                                                            for="Yes" class="ka-em-rbn-label">Yes</label>
                                                    </div>

                                                </div>
                                                <div class="col">
                                                    <div class="btn-holder">
                                                        <input type="radio" class="ka-em-radio-btn" value="No" id="No"
                                                            name="radio"
                                                            (change)="isSeletedYesOrNo($event.target.value)"><label
                                                            for="No" class="ka-em-rbn-label">No</label>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>


                                    </div>
                                    <div class="row" *ngIf="isSelectedToSendOTP==='Yes'">
                                        <form class="" [formGroup]="otpForm">
                                            <!-- <label class="text-left ka-float-left "
                                            for="defaultContactFormName">
                                            OTP</label>
                                        <input type="text" formControlName="otp" id="defaultContactFormName" mdbInput
                                            class="form-control " placeholder="Enter OTP" required>
                                        <div *ngIf="otpForm.controls['otp'].errors && !otpForm.controls['otp'].pristine "
                                            class="error-msg1">
                                            <div [hidden]="!otpForm.controls['otp'].errors.required">OTP is required.
                                            </div>
                                            <div [hidden]="!otpForm.controls['otp'].errors.pattern">
                                                Enter the Valid OTP
                                            </div>
                                        </div> -->

                                            <label class="mt-3" style="padding-left: 21px;">Enter OTP<span
                                                    class="ka-em-requried">*</span></label>
                                            <div class="row mt-3  ka-otp-input" style="justify-content: center;">


                                                <div class="row ka-otp-input" style="padding-left: 31px;">
                                                    <div class="col-2">
                                                        <input type="number" #otp1 maxlength="1" max="1"
                                                            class="form-control" formControlName="otp1"
                                                            (keypress)="omit_special_char_withNumbers_custom($event)"
                                                            (input)="onInputEntry($event, otp2, undefined, 'otp1')"
                                                            (focus)="onFocusInput($event)"
                                                            [ngClass]="{ 'ka-invlid-textBox':  otpForm.controls['otp1'].errors }">
                                                    </div>
                                                    <div class="col-2">
                                                        <input type="number" #otp2 maxlength="1" max="1"
                                                            class="form-control" formControlName="otp2"
                                                            (keypress)="omit_special_char_withNumbers_custom($event)"
                                                            [ngClass]="{ 'ka-invlid-textBox':   otpForm.controls['otp2'].errors }"
                                                            (input)="onInputEntry($event, otp3,otp1,'otp2')">
                                                    </div>
                                                    <div class="col-2">
                                                        <input type="number" #otp3 maxlength="1" max="1"
                                                            class="form-control" formControlName="otp3"
                                                            (keypress)="omit_special_char_withNumbers_custom($event)"
                                                            [ngClass]="{ 'ka-invlid-textBox': otpForm.controls['otp3'].errors }"
                                                            (input)="onInputEntry($event, otp4,otp2,'otp3')">
                                                    </div>
                                                    <div class="col-2">
                                                        <input type="number" #otp4 maxlength="1" max="1"
                                                            class="form-control" formControlName="otp4"
                                                            (keypress)="omit_special_char_withNumbers_custom($event)"
                                                            [ngClass]="{ 'ka-invlid-textBox':  otpForm.controls['otp4'].errors }"
                                                            (input)="onInputEntry($event, otp5,otp3,'otp4')">
                                                    </div>
                                                    <div class="col-2">
                                                        <input type="number" max="1" #otp5 maxlength="1"
                                                            class="form-control" formControlName="otp5"
                                                            (keypress)="omit_special_char_withNumbers_custom($event)"
                                                            [ngClass]="{ 'ka-invlid-textBox':   otpForm.controls['otp5'].errors }"
                                                            (input)="lastInput($event,otp4,'otp5')">
                                                    </div>
                                                    <div *ngIf="otpForm.controls['otp5'].errors" style="margin-top: 0; position: inherit !important; text-align: left !important;
                                                     margin-left: 27px;" class="invalid-feedback">
                                                        <div *ngIf="otpForm.controls['otp5'].errors.required">
                                                            OTP required to verify your mobile number
                                                        </div>
                                                    </div>

                                                </div>
                                                <div>

                                                </div>

                                            </div>


                                            <button mdbBtn
                                                class="ka-white-button tButton ka-btn-primary btn-success btn ka-custom-button-login mb-3"
                                                mdbWavesEffect type="submit" [disabled]="!otpForm.valid"
                                                (click)="verifyMobileOtp()">Submit</button>
                                        </form>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                    <!--Grid column-->



                </div>
            </div>
        </div>

    </div>


    <div mdbModal #warningMessageModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
        aria-labelledby="myBasicModalLabel" aria-hidden="true"
        [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
        <div class="modal-dialog modal-md modal-dialog-centered" role="document">

            <div class="modal-content">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="warningMessageModal.hide()">
                    <span aria-hidden="true" class="">&times;</span>
                </button>
                <div class="row text-left">

                    <!--Grid column-->
                    <div class="col-md-12 rmSectionPopup">
                        <div class="row p-2 m-2">

                            <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                                <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                                <p class="mt-2 p-0">{{responseMessage}} </p>

                                <div class="action-buttons">
                                    <button mdbBtn
                                        class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                                        mdbWavesEffect type="submit" (click)="warningMessageModal.hide()">ok
                                    </button>



                                </div>

                            </div>
                        </div>

                    </div>

                    <!--Grid column-->



                </div>
            </div>
        </div>
    </div>
    <!-- <div class="col-md-12" *ngIf="glleryClicked">
        <app-image-slider [profileDataImages]="profileDataImages" (closeEventTrigger)="closeModalPreviewImage($event)">
        </app-image-slider>
    </div> -->